<template>
<v-dialog v-model="this.show" persistent max-width="500">
  <app-edit-password-dialog :id="userId" :show="editPassword" :onDismiss="dismissEditPassword" :onSubmit="onSubmitPassword"></app-edit-password-dialog>
  <v-card>
    <v-card-title primary-title>
      <div>
        <div class="headline">Edit User</div>
      </div>
      <v-spacer></v-spacer>
      <v-menu offset-y>
        <v-btn icon slot="activator">
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile @click="showResetPasswordDialog">
            <v-list-tile-title>Change password</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row v-if="error">
          <v-col cols="12">
            <app-alert @dismissed="dismiss" :title="error.title" :text="error.message"></app-alert>
          </v-col>
        </v-row>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="firstName"
                :rules="[rules.required]"
                label="First name *"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
              v-model="lastName"
              :rules="[rules.required]"
              label="Last name *"
              required
            ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="email"
                :rules="[rules.required, rules.emailValid]"
                label="E-mail *"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="dismiss">Cancel</v-btn>
            <v-btn @click="submit" class="primary" :disabled="loading" :loading="loading">Submit</v-btn>
        </v-card-actions>
        </v-form>
      </v-container>
    </v-card-text>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  props: ['show', 'onDismiss', 'user'],
  data () {
    return {
      valid: true,
      editPassword: false,
      userId: this.user.id,
      firstName: this.user.firstName,
      lastName: this.user.lastName,
      email: this.user.email,
      rules: {
        required: v => !!v || 'Required.',
        agree: v => !!v || 'You must agree to continue!',
        min: v => (v !== undefined && v.length >= 8) || 'Min 8 characters',
        emailValid: v => /.+@.+/.test(v) || 'E-mail must be valid',
        match: v => v === this.password || 'Passwords don\'t match'
      }
    }
  },
  watch: {
    user (value) {
      this.userId = value.id
      this.firstName = value.firstName
      this.lastName = value.lastName
      this.email = value.email
    }
  },
  mounted () {
    this.$store.dispatch('clearError')
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    submit () {
      if (this.$refs.form.validate()) {
        console.log('weve got one')
        var that = this
        var vendorId = this.$store.state.vendors.selectedItem.id
        this.$store.dispatch('vendorAccounts/update',
          {
            vendorId: vendorId,
            accountId: this.user.id,
            payload: {
              firstName: this.firstName,
              lastName: this.lastName,
              email: this.email
            }
          })
          .then(resp => {
            that.dismiss()
          })
      }
    },
    showResetPasswordDialog () {
      this.editPassword = true
    },
    dismissEditPassword () {
      this.editPassword = false
    },
    dismiss () {
      this.onDismiss()
      this.$refs.form.reset()
      this.$store.dispatch('clearError')
    },
    onSubmitPassword (newPassword) {
      var vendorId = this.$store.state.vendors.selectedItem.id
      this.$store.dispatch('vendorAccounts/update', {
        vendorId: vendorId,
        accountId: this.user.id,
        payload: {
          password: newPassword
        }
      }).then(resp => {
        this.editPassword = false
      })
    }
  }
}
</script>
